import { useState } from 'react';
import { useService } from '../hooks/useService';

/** 상담목표를 그 자리에서 바로 추가 (목표 탭까지 가지 않아도 되게) */
export function GoalQuickAdd({ clientId, onAdded }: { clientId: string; onAdded: () => void }) {
  const svc = useService();
  const [title, setTitle] = useState('');
  const [agreed, setAgreed] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const add = () => {
    if (!title.trim()) return;
    setBusy(true);
    setErr(null);
    void svc
      .createGoal(clientId, { title: title.trim(), agreedWithClient: agreed })
      .then(() => {
        setTitle('');
        onAdded();
      })
      .catch((e: Error) => setErr(e.message))
      .finally(() => setBusy(false));
  };
  return (
    <div className="stack">
      <div className="row">
        <input
          aria-label="새 상담목표"
          placeholder="상담목표 (예: 자기비판하는 시간을 줄인다)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && add()}
          style={{ flex: '1 1 220px' }}
        />
        <select aria-label="목표 종류" value={agreed ? 'agreed' : 'clinical'} onChange={(e) => setAgreed(e.target.value === 'agreed')}>
          <option value="agreed">내담자와 합의한 목표</option>
          <option value="clinical">임상적 목표 (상담자)</option>
        </select>
        <button type="button" className="primary" disabled={busy || !title.trim()} onClick={add}>
          목표 추가
        </button>
      </div>
      {err && (
        <p role="alert" className="warn small">
          {err}
        </p>
      )}
    </div>
  );
}
